// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__wc3yK","name":"Header_name__2EFVu","birthday":"Header_birthday__2pF1_","skeleton":"Header_skeleton__3QNur"};